export default __webpack_public_path__ + "static/hero-bcc6dfd62638f29cb70e3691852ee0df.jpg";